import { Button } from '@betterment/samba-react';

type CsvDownloadButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

export const CsvDownloadButton: React.FC<CsvDownloadButtonProps> = ({ disabled, onClick }) => {
  return (
    <Button onClick={onClick} spacing="compact" variant="ghostPrimary" disabled={disabled}>
      <Button.Icon name="Download" />
      CSV
    </Button>
  );
};
